import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TaraCard } from './ui/TaraCard';
import TaraButton from './ui/TaraButton';

const OnboardingStep = ({ 
  step, 
  totalSteps = 5, 
  title, 
  reassurance, 
  children,
  trustNote,
  onContinue,
  onBack,
  continueDisabled = false,
  showBack = true,
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-cosmic-dawn px-5 py-8">
      {/* Back Button */}
      {showBack && (
        <button 
          onClick={() => onBack ? onBack() : navigate(-1)}
          className="mb-8 p-2 hover:bg-stone-100 rounded-full transition-colors"
        >
          <ChevronLeft className="w-6 h-6 text-stone-700" />
        </button>
      )}
      
      {/* Stepper */}
      <div className="max-w-md mx-auto mb-12">
        <div className="flex items-center justify-between mb-2">
          {[...Array(totalSteps)].map((_, i) => (
            <div key={i} className="flex items-center flex-1">
              <div className={`
                w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all
                ${i + 1 === step 
                  ? 'bg-cosmic-500 text-white' 
                  : i + 1 < step 
                  ? 'bg-cosmic-200 text-cosmic-700'
                  : 'bg-stone-200 text-stone-500'
                }
              `}>
                {i + 1 < step ? '✓' : i + 1}
              </div>
              {i < totalSteps - 1 && (
                <div className={`h-0.5 flex-1 mx-2 transition-all ${
                  i + 1 < step ? 'bg-cosmic-200' : 'bg-stone-200'
                }`} />
              )}
            </div>
          ))}
        </div>
        <p className="text-xs text-stone-600 text-center">
          Step {step} of {totalSteps}
        </p>
      </div>
      
      {/* Content */}
      <div className="max-w-md mx-auto space-y-8">
        {/* Title */}
        <div className="text-center space-y-2">
          <h1 className="font-serif text-3xl md:text-4xl font-medium text-stone-900 leading-tight">
            {title}
          </h1>
          <p className="text-sm text-stone-600">
            {reassurance}
          </p>
        </div>
        
        {/* Input Card */}
        <TaraCard variant="default" className="shadow-card-hover">
          {children}
        </TaraCard>
        
        {/* Trust Note */}
        {trustNote && (
          <p className="text-xs text-center text-stone-500 leading-relaxed px-4">
            {trustNote}
          </p>
        )}
        
        {/* Continue Button */}
        <TaraButton
          variant="sacred"
          size="lg"
          onClick={onContinue}
          className="w-full"
          disabled={continueDisabled}
        >
          Continue
        </TaraButton>
      </div>
    </div>
  );
};

export default OnboardingStep;